import React, { useContext } from "react";
import { ClavaContext } from "../../../config/contexts";
import { translate, TranslatorKeys } from "../../../config/translator";
import LoadingSpinner from "../LoadingSpinner";
import CardPanel from "../CardPanel";

type EmptyStateProps = {
  messageKey?: TranslatorKeys;
  message?: string;
  loading?: boolean;
  loadingMessageKey?: TranslatorKeys;
  loadingMessage?: string;
  withCard?: boolean;
  className?: string;
};

const EmptyState: React.FC<EmptyStateProps> = ({
  messageKey,
  message,
  loading = false,
  loadingMessageKey,
  loadingMessage,
  withCard = true,
  className = "",
}) => {
  const { l } = useContext(ClavaContext);

  const displayMessage = loading
    ? (loadingMessage ?? (loadingMessageKey ? translate(loadingMessageKey, l) : undefined))
    : (message ?? (messageKey ? translate(messageKey, l) : undefined));

  const content = (
    <div className={`flex items-center justify-center gap-2 p-4 ${className}`}>
      {loading && <LoadingSpinner size="sm" />}
      {displayMessage && (
        <span className="text-font dark:text-font-dark text-xs">
          {displayMessage}
        </span>
      )}
    </div>
  );

  if (withCard) {
    return (
      <CardPanel className="w-full">
        {content}
      </CardPanel>
    );
  }

  return content;
};

export default EmptyState;



